export default __webpack_public_path__ + "static/media/weather_app.6c0ef74a.png";